/// <reference path="../../typings.d.ts" />
import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTitle } from '../shared/title';
import { IdentityService } from '../services/identity.service';
import { Alert } from '../shared/alert';
import { validateToken } from '../services/account.service';
import { isDateSet, dateFormat } from '../shared/date_helper';
import { IdPUser } from '../models/idpuser';
import { IdPUserTextSearch } from '../models/idpuser_text_search';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';

@Component({
	selector: 'users',
	styles: [`
        .tag {
            margin-right:2px;
            background-color:#9dbd9e;
            border-radius:4px;
            padding:5px;
        }
        .tag-close {
            margin-left:5px;
            cursor: pointer;
        }
    `],
	template: `
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-8 col-md-7 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="add()">Add New</button>
                <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
				</div>
				<div class="col-lg-4 col-md-5 col-xs-8">
					<div class="input-group">
						<input class="form-control" type="text" (keyup.enter)="refresh()" [(ngModel)]="fobj.query" placeholder="Search"/>
						<span class="input-group-btn">
							<button class="btn btn-default" type="button" (click)="refresh()"> <span class="glyphicon glyphicon-search"></span> </button>
						</span>
					</div>
					<p style="text-align:right">
						<a style="cursor: pointer;" (click)="deleteAllConfirmation()">delete all</a>
					</p>
				</div>
				<div class="row" [hidden]="msgYesNo.msg == ''">
					<div class="col-lg-8 col-md-6 col-xs-12">
						<alert-yesno [alert]="msgYesNo" (respond)="msgYesNoRespond($event)" style="display:block;margin-top:10px;"></alert-yesno>
					</div>
		 		</div>
		    <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="card">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>IdP Name</th>
                                <th>Username</th>
                                <th>First Name</th>
                                <th>Last Name</th>
										  <th>Card ID</th>
										  <th>Group Names</th>
										  <th>Created At</th>
										  <th>Last Login At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of data; let i = index">
                                <td style="width:10%;">{{ row.idpName }}</td>
                                <td style="width:15%;">{{ row.username }}</td>
                                <td style="width:10%;">{{ row.firstName }}</td>
                                <td style="width:10%;">{{ row.lastName }}</td>
								<td style="width:8%;">{{ row.cardId }}</td>
								<td style="width:10%;">
									<span title="{{ row.groupNames }}" (click)="expandGroupName(row)" [style.cursor]="cursorStyle(row)">{{ truncateText(row) }}</span>
								</td>
                                <td style="width:12%;">{{ printDate(row.createdAt) }}</td>
								<td style="width:12%;">{{ printDate(row.lastLoginAt) }}</td>
                                <td style="width:15%;">
                                    <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                                    <span title="Roles" class="btn-link" style="cursor: pointer;" (click)="roles(row)">Roles</span> |
                                    <span title="Remove User" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="remove(row)" style="cursor:pointer;"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
		  </div>
		  <div class="row" *ngIf="data.length > 0" style="">
            <div class="col-lg-5">
                <button class="btn btn-default" type="button" title="First Page" [disabled]="disablePreviousPage" (click)="firstPage()">&lt;&lt;</button>
                <button class="btn btn-default" type="button" title="Previous Page" [disabled]="disablePreviousPage" (click)="prevPage()">&lt;</button>
                <span>{{getFromPage()}}-{{getToPage()}} of {{rowCount}}</span>
                <button class="btn btn-default" type="button" title="Next Page" [disabled]="disableNextPage" (click)="nextPage()">&gt;</button>
            </div>
        </div>
    `
})

export class IdPUsersListComponent implements OnInit {
	data: IdPUser[];
	msg: Alert;
	msgYesNo: Alert;
	msgHead: Alert;
	acctNumber: string;
	hasAccess: boolean;
	maxPageSize: number;
	fobj: IdPUserTextSearch;
	fromPage: number;
	toPage: number;
	rowCount: number;
	disablePreviousPage: boolean;
	disableNextPage: boolean;
	searchQueryParam: string;
	pageSizeParam: string;
	pageParam: string;
	private subscriptionQueryParams: Subscription;

	constructor(private router: Router, private idsvc: IdentityService, private title: AppTitle, private activatedRoute: ActivatedRoute) {
		this.hasAccess = true;
		this.msg = new Alert();
		this.msgHead = new Alert();
		this.msgYesNo = new Alert();
		title.setTitles({
			title: 'IdP Users',
			dashboard: 'IdP Users'
		});
		this.title.setBreadcrumbs([
			{ title: 'IdP Users', link: `` }
		]);
		this.maxPageSize = 20;
		this.fobj = new IdPUserTextSearch()
		this.fobj.pageSize = this.maxPageSize;
		this.data = [];

		this.fromPage = 0;
		this.toPage = 0;
		this.rowCount = 0;
		this.disablePreviousPage = true;
		this.disableNextPage = true;
		this.subscriptionQueryParams = activatedRoute.queryParams.subscribe(
			(params) => {
				this.searchQueryParam = params['searchQuery'];
				this.pageSizeParam = params['pageSize']
				this.pageParam = params['page']
				this.setFormNavParams(this.fobj);
			}
		);

	}

	ngOnInit() {
		this.acctNumber = this.activatedRoute.snapshot.params['acctnumber'];
		if (this.acctNumber != null) {
			this.idsvc.validateAcctNumber(this.acctNumber)
				.subscribe(res => {
					if (!res) {
						this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
						this.hasAccess = false;
					}
				}, err => {
					console.log(err);
					let e = this.idsvc.getUserErrorDefault(err);
					this.msgHead.error(e);
					this.hasAccess = false;
				})
		}
		this.loadData();
	}

	loadData() {
		this.data = [];

		this.idsvc.textSearchIdPUsersApi(this.acctNumber, this.fobj).subscribe((rows: IdPUser[]) => {
			for (let e of rows) {
				this.data.push(e);
			}
			this.rowCount = rows.length;
			this.disablePreviousPage = this.fobj.page == 1;
			this.maxPageSize = this.fobj.pageSize;
			if (this.data.length >= this.maxPageSize) {
				this.fromPage = (this.maxPageSize * (this.fobj.page - 1)) + 1;
				this.toPage = (this.maxPageSize * (this.fobj.page));
			} else {
				this.fromPage = (this.maxPageSize * (this.fobj.page - 1)) + 1;
			}

			this.idsvc.textSearchCountIdPUsersApi(this.acctNumber, this.fobj).subscribe(resp => {
				let count = resp.count;
				this.rowCount = count;
				if (this.data.length < this.maxPageSize) {
					this.toPage = count;
				}
				this.disableNextPage = this.getToPage() >= count;
			}, err => {
				console.log(err);
				if (this.idsvc.isErrNotFound(err)) {
					this.msg.warning(this.idsvc.getUserError(err));
				} else {
					this.msg.error(this.idsvc.getUserErrorDefault(err));
				}
			});
		}, err => {
			console.log(err);
			if (this.idsvc.isErrNotFound(err)) {
				this.msg.warning(this.idsvc.getUserError(err));
			} else {
				if (this.idsvc.isErrUnauthorized(err)) {
					this.hasAccess = false;
					this.msg.error(this.idsvc.getUserErrorDefault(err));
				} else {
					this.msg.error(this.idsvc.getUserErrorDefault(err));
				}
			}
		});

	}

	refresh() {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.loadData();
		this.msg.close();
	}

	add() {
		this.router.navigate([`idp/${this.acctNumber}/idp-users/users/add`]);
		return;
	}

	edit(ids: IdPUser) {
		let params: any = {};
		params['username'] = ids.username;
		params['idpName'] = ids.idpName;
		this.router.navigate([`idp/${this.acctNumber}/idp-users/${ids.idpId}/users/${ids.userId}/edit`], { queryParams: this.idsvc.params(params) });
		return;
	}

	roles(ids: IdPUser){
		var params: any = {};
		params['username'] = ids.username;
		params['idpName'] = ids.idpName;
		this.router.navigate([`idp/${this.acctNumber}/idp-users/${ids.idpId}/users/${ids.userId}/roles`], { queryParams: this.idsvc.params(params) });
		return;
	}

	remove(reg: IdPUser) {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.idsvc.removeIdPUsersApi(this.acctNumber, reg.id)
			.subscribe(res => {
				this.data.splice(this.data.indexOf(reg), 1);
			}, err => {
				console.log(err);
				let e = this.idsvc.getUserErrorDefault(err);
				this.msgHead.error(e);
			});
	}

	printDate(d: Date): string {
		let df = '01/02/2006 03:04 PM';
		if (isDateSet(d)) {
			return dateFormat(d, df);
		}
		return '';
	}

	setNavParams(req: IdPUserTextSearch): Observable<boolean> {
		var params: any = {};

		params['searchQuery'] = req.query;
		params['page'] = req.page;
		params['pageSize'] = req.pageSize;

		let p = this.router.navigate([`idp/${this.acctNumber}/idp-users/users`], { queryParams: this.idsvc.params(params) });

		return Observable.create((observer: Observer<boolean>) => {
			p.then(() => {
				observer.next(true);
				observer.complete();
			});
		});
	}

	setFormNavParams(f: IdPUserTextSearch) {
		let dec = decodeURIComponent;
		f.query = this.searchQueryParam != null ? dec(this.searchQueryParam) : '';
		f.pageSize = this.pageSizeParam != null ? parseInt(dec(this.pageSizeParam)) : 20;
		f.page = this.pageParam != null ? parseInt(dec(this.pageParam)) : 1;
	}

	deleteAllConfirmation() {
		this.msg.close();
		this.msgYesNo.warningHtml(`Are you sure to remove all results from current search?`);
	}

	msgYesNoRespond(respond: any) {
		if (respond == 'yes') {
			this.setNavParams(this.fobj).subscribe(() => {
				this.msgYesNo.close();
				this.deleteAll();
			});
		} else if (respond == 'no') {
			this.msgYesNo.close();
			this.setNavParams(this.fobj).subscribe(() => { });
		}
	}

	deleteAll() {
		this.msg.info('Removing results from current search ...');
		this.idsvc.removeAllIdPUsersApi(this.acctNumber, this.fobj)
			.subscribe(res => {
				this.data = [];
				this.msg.success('Successfully removed all results from current search.');
				if (this.fobj.query != '') {
					this.fobj.query = '';
					this.refresh();
				}
			}, err => {
				console.log(err);
				let e = this.idsvc.getUserErrorDefault(err);
				this.msg.error(e);
			});
	}

	getFromPage(): number {
		return this.fromPage;
	}

	getToPage(): number {
		return this.toPage;
	}

	prevPage() {
		if (this.fobj.page > 1) {
			this.fobj.page -= 1;
			this.setNavParams(this.fobj).subscribe(() => {
				this.loadData()
			});
		}
	}

	firstPage() {
		if (this.fobj.page > 1) {
			this.fobj.page = 1;
			this.setNavParams(this.fobj).subscribe(() => {
				this.loadData()
			});
		}
	}

	nextPage() {
		if (this.data.length >= this.maxPageSize) {
			this.fobj.page = this.fobj.page + 1;
			this.setNavParams(this.fobj).subscribe(() => {
				this.loadData()
			});
		}
	}

	truncateText(row): string {
		var limit = 30;
		var value = row.groupNames;
		if (value && value.length > limit) {
			if (row.isExpanded) {
				return value;
			}
			return value.substring(0, limit) + '...';
		}
		return value;
	}

	expandGroupName(row){
		row.isExpanded = !row.isExpanded;
	}

	cursorStyle(row){
		return row.groupNames.length > 30 ? 'pointer' : 'auto'
	}

}
